import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome',
	templateUrl:'./FontAwesomePluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomePluginCompPage
{
	mdContent_947 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.FontAwesome;
\`\`\``;
	mdContent_948 = `\`\`\`java
FontAwesome(FontAwesomeStyles style, IFontAwesomeIcon icon)
\`\`\``;
	mdContent_949 = `\`\`\`java
FontAwesome()
\`\`\``;
	mdContent_950 = `\`\`\`java
var icon = new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.cog)
    .setSize(FontAwesomeSizes.$3x);
\`\`\``;
	mdContent_951 = `\`\`\`java
var github = new FontAwesome<>(FontAwesomeStyles.Brand, FontAwesomeBrandIcons.github);
\`\`\``;
	mdContent_952 = `\`\`\`java
var spinner = new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.spinner)
    .spin()
    .setSize(FontAwesomeSizes.$2x)
    .transform(FontAwesomeTransforms.Grow_4);
\`\`\``;
	mdContent_953 = `\`\`\`java
var icon = new FontAwesome<>(FontAwesomeStyles.Duotone, FontAwesomeIcons.calendar)
    .primaryColour("#2196F3")
    .secondaryColour("#90CAF9");
\`\`\``;
	mdContent_954 = `\`\`\`java
var masked = IFontAwesome.createMaskIcon(
    FontAwesomeIcons.pencil, FontAwesomeStyles.Classic,
    FontAwesomeIcons.circle, FontAwesomeStyles.Classic);
\`\`\``;
	mdContent_955 = `\`\`\`java
// Simple icon
var home = FontAwesome.icon(FontAwesomeIcons.home);

// Icon with style
var star = FontAwesome.icon(FontAwesomeIcons.star, FontAwesomeStyles.Filled);

// Icon with size and style
var bell = FontAwesome.icon(FontAwesomeIcons.bell, FontAwesomeSizes.Lg, FontAwesomeStyles.Classic);
\`\`\``;
}
